<template>
  <modal :show="show" :noteId="noteId" @close="close()" id="note-edit">
    <div class="modal-head">
      <h2>Edit Note</h2>
    </div>

    <div class="modal-content">
      <form @submit.prevent="update()">
        <div class="form-control">
          <label for="message">Message</label>
          <textarea v-model="note" name="message" id="message"></textarea>
        </div>

        <button class="button button-green">Update</button>
        <button @click.prevent="close()" class="button button-gray">Cancel</button>
      </form>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/ui/Modal";

export default {
  name: "NoteEdit",
  props: ["show", "noteId"],
  components: {
    Modal
  },
  data() {
    return {
      note: null
    };
  },
  async created() {
    let note = await this.$http.get("/global-notes/" + this.noteId);
    this.note = note.data.message;
  },
  methods: {
    async update() {
      let response = await this.$http.put("/global-notes/" + this.noteId, {
        message: this.note
      });
      this.$emit("update");
      this.$emit("close");
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
#note-edit {
}
</style>
